import axiosInstance from './axiosInstance';

const getToUpById = (toUpId) =>
  axiosInstance.get(`/internal/admin/top_up/${toUpId}`);

export default getToUpById;
